export default "__VITE_ASSET__IgwukKji__"